import { httpClient } from '@/infra/protocols/http';
import { IEpisodeDetailsDTO } from '@/modules/episodes/dtos/episode.dto';
import { IMusic } from '@/modules/musics/entities/music.entity';

export async function getAssociatedMusic(
  params: GetAssociatedMusicService.Params,
): Promise<GetAssociatedMusicService.Response> {
  const response = await httpClient.get<IEpisodeDetailsDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}`,
  );
  return response.musicaEmUso
    ? {
        duration: 0,
        id: response.musicaEmUso.id,
        name: response.musicaEmUso.nome,
        description: response.musicaEmUso.descricao,
        previewUrl: response.musicaEmUso.previewAudio,
      }
    : null;
}

export namespace GetAssociatedMusicService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Response = IMusic | null;
}
